import { FC, ReactNode, useMemo, useRef, useState, CSSProperties, } from "react";
// 组件
import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import { ProButton, ProTooltip, ProTypography } from '../antd';
// 方法
import classNames from "classnames";
// 常量
import { ButtonProps } from 'antd/lib/button';
import './style.less';

export interface CopySyncProps {
  /** 样式 */
  className?: string;
  /** 类名 */
  style?: CSSProperties;
  /** 复制按钮配置 */
  copyButtonProps?: ButtonProps;
  /** 复制按钮文字 */
  copyButtonText?: ReactNode;
  /** 是否需要Tooltip提示 */
  isTooltip?: boolean;
  /** 子节点 */
  children?: ReactNode;
  /** 复制成功 */
  onCopySuccess?: () => void;
  /** 获取复制文字 */
  formatCopyText: (() => Promise<string>) | (() => string);
};
enum COPY_TEXT {
  TEXT = '复制',
  SUCCESS = '复制成功',
};
/** 异步复制 */
const CopySync: FC<CopySyncProps> = props => {
  const { formatCopyText, onCopySuccess, className, style, copyButtonProps, copyButtonText, isTooltip, children, } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [tooltipTitle, setTooltipTitle] = useState<COPY_TEXT>(COPY_TEXT.TEXT);
  const [copyText, setCopyText] = useState<string>();
  const copyDiv = useRef<HTMLDivElement>(null);
  const timer = useRef<any>();
  /** 复制成功 */
  const handleCopy = () => {
    clearTimeout(timer.current);
    setTooltipTitle(COPY_TEXT.SUCCESS);
    onCopySuccess?.();
    timer.current = setTimeout(() => {
      setTooltipTitle(COPY_TEXT.TEXT);
    }, 3000);
  };
  /** 点击复制按钮 */
  const handleClick = async () => {
    if (tooltipTitle === COPY_TEXT.SUCCESS || loading) return;
    setLoading(true);
    const newCopyText = await formatCopyText();
    setLoading(false);
    setCopyText(newCopyText);
    setTimeout(() => {
      if (!copyDiv.current) return;
      const copyIcon = copyDiv.current.getElementsByClassName('ant-typography-copy')[0] as HTMLDivElement;
      copyIcon.click();
    }, 200);
  };
  const childrenNode = useMemo(() => {
    if (children) return children;
    return (
      <ProButton
        {...copyButtonProps}
        loading={loading}
        icon={tooltipTitle === COPY_TEXT.SUCCESS ? <CheckOutlined /> : <CopyOutlined />}
      >{copyButtonText}</ProButton>
    );
  }, [tooltipTitle, copyButtonText, loading, copyButtonProps]);
  const classes = useMemo(() => {
    return classNames('yb-copy-sync', className);
  }, [className]);
  return (
    <div className={classes} style={style}>
      <div onClick={handleClick}>
        {
          isTooltip ? (
            <ProTooltip title={tooltipTitle}>
              {childrenNode}
            </ProTooltip>
          ) : childrenNode
        }
      </div>
      <div ref={copyDiv} className="hide">
        <ProTypography.Paragraph
          className="margin-bottom-0"
          copyable={{
            text: copyText,
            icon: <CopyOutlined />,
            onCopy: handleCopy,
          }}
        />
      </div>
    </div>
  );
};

CopySync.defaultProps = {
  copyButtonText: '复制',
  isTooltip: true,
};

export default CopySync;
